'use client'
import {
  EditorialCard,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import { useRouter } from 'next/navigation'
import {
  EditorialCardProps,
  OnClickProps,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

interface RecipesCardsProps {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    editorialCards: EditorialCardProps[]
    onClick: OnClickProps
  }
}

function RecipesCards({ modelledContent, ...props }: RecipesCardsProps) {
  const router = useRouter()
  const { openingTitle, title, paragraph, editorialCards, onClick } =
    modelledContent
  const openingTitleLabel = openingTitle?.content || ''
  const titleLabel = title?.content || ''
  const paragraphContent = paragraph?.content || ''

  const renderEditorialCards = () => {
    if (!editorialCards) return null

    return editorialCards.map((card, index) => {
      const { href } = card.onClick as unknown as OnClickProps
      const routerPush = () => router.push(href)

      return (
        <EditorialCard
          key={index}
          {...card}
          onClick={routerPush}
          className={`section-recipes-cards__content-wrapper__cards__card`}
        />
      )
    })
  }

  return (
    <Section className={`section-recipes-cards`}>
      <div className='section-recipes-cards__content-wrapper'>
        <div className='section-recipes-cards__content-wrapper__head'>
          <div className='section-recipes-cards__content-wrapper__head__title-wrapper'>
            {openingTitleLabel ? (
              <OpeningTitle
                className='section-recipes-cards__content-wrapper__head__title-wrapper__opening-title'
                {...openingTitle}
              >
                {openingTitleLabel}
              </OpeningTitle>
            ) : null}
            {titleLabel ? (
              <Title
                className='section-recipes-cards__content-wrapper__head__title-wrapper__title'
                {...title}
                dangerouslySetInnerHTML={{ __html: titleLabel }}
              />
            ) : null}
          </div>
          {paragraphContent ? (
            <Paragraph
              className={`section-recipes-cards__content-wrapper__head__paragraph`}
              dangerouslySetInnerHTML={{ __html: paragraphContent }}
            />
          ) : null}
        </div>
        <div className='section-recipes-cards__content-wrapper__cards'>
          {renderEditorialCards()}
        </div>
      </div>
    </Section>
  )
}

export default RecipesCards
